import gql from 'graphql-tag';

export const deleteMOCEventCategory = gql`
  mutation deleteMOCEventCategory($id: String) {
    deleteMOCEventCategory(id: $id)
  }
`;
